import React, { useState, useEffect } from 'react';
import {
  Link,
  StructuredListRow,
  Toggle,
  StructuredListCell,
} from '@carbon/react';
import './feature-row.scss';
import { SettingsAdjust } from '@carbon/react/icons';
import useModal from '@/lib/hooks/useModal';

const FeatureRow = ({ name, description, currentState, onChange }) => {
  const [openFeatureSettings] = useModal('FEATURE_SETTINGS');

  const [state, setState] = useState({
    enabled: false,
    settings: {},
    name: name,
  });

  useEffect(() => {
    setState(
      currentState || {
        enabled: false,
        settings: {},
        name: name,
      }
    );
  }, [currentState, name]);

  const onToggle = () => {
    console.info("on Toggle")
    onChange(name, {
      ...state,
      enabled: !state.enabled,
    });
  };

  const onSubmitForm = (new_state) => {
    onChange(name, {
      ...state,
      settings: new_state,
    });
  };

  const openSettings = () => {
    openFeatureSettings({name, current_settings: state.settings, onSubmit: onSubmitForm})
  };

  return (
    <StructuredListRow>
      <StructuredListCell>
        <Toggle
          size="sm"
          id={`feature_${name}_toggle`}
          labelA=""
          labelB=""
          onToggle={onToggle}
          toggled={state.enabled}
          aria-label="aktivieren"
          labelText=""
        />
      </StructuredListCell>
      <StructuredListCell className="feature-list-cell-description">
        <div>{description}</div>
      </StructuredListCell>
      <StructuredListCell>
        <Link href="#" onClick={openSettings}>
          <SettingsAdjust size={20} />
        </Link>
      </StructuredListCell>
    </StructuredListRow>
  );
};

export default FeatureRow;
